import axios from 'axios'
import {Config} from '../utils/Config'
import {isEmpty} from 'lodash'

const getToken = () => {
  const token = localStorage.getItem('token')

  return token ? `Bearer ${token}` : null
}

const clientForm = axios.create({
  responseType: 'json',
  baseURL: Config.BASE_URL,
  transformResponse: response => response,
})

clientForm.defaults.headers.post['Content-Type'] = 'multipart/form-data'
clientForm.defaults.headers.post.Accept = 'application/json'
clientForm.defaults.headers.pragma = 'no-cache'
clientForm.defaults.withCredentials = false
clientForm.defaults.timeout = 120000

const client = axios.create({
  responseType: 'json',
  baseURL: Config.BASE_URL,
  transformResponse: response => response,
})

client.defaults.headers.post['Content-Type'] = 'application/json'
client.defaults.headers.post.Accept = 'application/json'
client.defaults.headers.pragma = 'no-cache'
client.defaults.withCredentials = false
client.defaults.timeout = 120000

const request = options => {
   var token = getToken()

   if (token) {
     client.defaults.headers.common.Authorization = token
   } else {
     delete client.defaults.headers.common.Authorization
   }

  const onSuccess = response => {
    if (typeof response.data === 'string') return JSON.parse(response.data)
    else return response.data
  }

  const onFailure = error => {
    const {response, status, message, headers, data} = error
    const UN_AUTHORIZED = 401
    const FORBIDDEN = 403
    if (
      (response &&
        (response.status === UN_AUTHORIZED || response.status === FORBIDDEN)) ||
      status === UN_AUTHORIZED ||
      status === FORBIDDEN
    ) {
      console.error('status:', status)
      console.error('data:', data)
      console.error('headers:', headers)
      // will call logout function here
      window.location = '/login'
    } else {
      console.error('error message', message)
      if (isEmpty(response)) {
        var errorResponse = {message, success: false}
        return Promise.reject(errorResponse)
      }
    }

    // Carry the status through, and stop the handler throwing on its way out.
    //
    // This used to be `JSON.parse(response.data) || JSON.parse(message)`. An error body that is not
    // JSON makes that throw a SyntaxError from inside the failure handler, and the caller sees a
    // parse error instead of the response - which is what an ASP.NET NotFound() produces, because it
    // has no body at all. So a 404 could never be recognised as a 404 by anything upstream.
    //
    // The rejected value keeps its previous shape, so callers reading fields off the parsed body are
    // unaffected; status is added alongside for callers that need to tell one failure from another.
    const parseOrNull = value => {
      if (value == null) return null
      if (typeof value === 'object') return value
      try {
        return JSON.parse(value)
      } catch (parseError) {
        return null
      }
    }

    const body = parseOrNull(response.data) || parseOrNull(message) || {}
    if (body && typeof body === 'object' && body.status === undefined) {
      body.status = response.status
    }

    return Promise.reject(body)
  }
  if (options.contentType) {
    return clientForm(options).then(onSuccess).catch(onFailure)
  }

  return client(options).then(onSuccess).catch(onFailure)
}

export default request
